// extracted by mini-css-extract-plugin
module.exports = {"triangle":"NotificationPopup_triangle__0Hp9_"};